/* 左边的品牌列表 */
import React, { useRef, useState, useEffect } from 'react'

import classnames from 'classnames'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import buildUrl from 'Pages/auto/home/utils'
import { ContextStore } from './reducer'
import { useRouter } from 'next/router'
import { IConditionsProps, IInfoProps, ISortProps } from './interface'
import Link from 'next/link'

import { sort, conditions } from './conditions-config'

import SingleList from './single-list'
import MultipleList from './multiple-list'

interface IProps {
  handleOptionClick: (item: ISortProps, line: number, clearLine?: number) => void
  isOptionActive: (option: ISortProps, line: number) => boolean
}

// ["3 变速箱", "5 排量", 13 气缸数  "8 驱动方式", 14进气方式 "9 安全配置", "10 舒适配置",]
const typeArr = [3, 5, 13, 8, 14, 9, 10];

export default function Other({ handleOptionClick, isOptionActive }: IProps) {
  const router = useRouter()
  const { state, dispatch } = React.useContext(ContextStore)


  function isActive(item: IConditionsProps) {
    if (item.template === 'hover-single') {
      return typeSingleValue(item)
    }
    if (item.template === 'hover-select') {
      return !!typeSelectValue(item).length
    }
  }

  function typeSingleValue(item: IConditionsProps) {
    if (item.template === 'hover-single') {
      const key = item?.data?.[0]?.['key'];
      if (state[key]?.[0]?.['param']) {
        return state[key]?.[0]?.['param']
      }
      return ''
    }
  }

  function typeSelectValue(item: IConditionsProps): string[] {
    // 多选
    if (item.template === 'hover-select') {
      let result = [];
      const length = item?.data?.length;
      for (let i = 0; i < length; i++) {
        const typeData = item?.data?.[i];
        const key = typeData?.['key'];
        if (state[key]?.[0]?.['param']) {
          result.push(key)
        }
      }
      if (result.length) {
        return result;
      }
    }
    return []
  }

  const allConditionKeys = React.useMemo(() => {
    return conditions.map(item => {
      return Array.from(
        new Set(item.data.map(item => item.key).filter(item => !!item))
      )
    })
  }, [conditions])
  // select change
  function handleSelectClick(value: string[], line: number, clearLine?: number) {
    // 第N行条件
    const currentLine = allConditionKeys[line]
    // dispatch({ type: 'conditions' })
    const newOptions = Object.assign({}, state)

    if (clearLine !== undefined) {
      // 可以指定清空特定行
      const clearLineItem = allConditionKeys[clearLine]
      clearLineItem.forEach(key => {
        newOptions[key] = []
      })
    }

    // 清空整行元素
    if (!value?.length) {
      currentLine.forEach(key => {
        newOptions[key] = []
      })
      router.push(
        `/auto/library/${buildUrl(newOptions, allConditionKeys)}${window?.location?.search
        }`,
        `/auto/library/${buildUrl(newOptions, allConditionKeys)}${window?.location?.search
        }`
      )
      return
    }

    value?.forEach(key => {
      // 初始值为空
      if (!newOptions[key]) {
        newOptions[key] = []
      }

      newOptions[key] = [
        {
          text: '',
          param: 1,
        },
      ]
    });

    router.push(
      `/auto/library/${buildUrl(newOptions, allConditionKeys)}${window?.location?.search
      }`,
      `/auto/library/${buildUrl(newOptions, allConditionKeys)}${window?.location?.search
      }`
    )
  }

  function renderList() {
    return (
      <div className="tw-flex">
        <ul className="car-wrap">
          {typeArr.map((index: number) => (
            <li
              key={`key-${index}`}
              className={classnames((`item-child big-mr other-child`), {
                active: isActive(conditions[index]),
                hasChildren: true
              })}
              onClick={(e: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
                e.preventDefault()
                e.stopPropagation()
                sendTeaCommEvent('click_brand_initial_index', {
                  initial: 'letter',
                })
              }}
            >
              {conditions[index]['title']}
              {
                conditions[index]['template'] === 'hover-single' && (
                  <div className="other-children" >
                    <SingleList options={conditions[index]?.data}
                      onChange={(item) => {
                        if (item && item.param !== 'all') {
                          handleOptionClick({
                            "param": item.param,
                            "text": item.text,
                            "key": item.key
                          }, index)
                          return
                        }
                      }}
                      value={typeSingleValue(conditions[index])} />
                  </div>
                )
              }
              {
                conditions[index]['template'] === 'hover-select' && (
                  <div className="other-children" >
                    <MultipleList
                      options={conditions[index]?.data}
                      name={conditions[index]['title']}
                      onChange={(item) => {
                        // 处理多种类型情况
                        handleSelectClick(item, index)
                      }}
                      value={typeSelectValue(conditions[index])} />
                  </div>
                )
              }
            </li>
          ))}
        </ul>
        <style jsx>
          {`
              .nolimit-mr{
                margin-right: 30px !important;
              }
              .nolimit-width{
                width: 47px;
              }
              li{
                position: relative;
              }
              .after.active:after{
                content: '';
                position: absolute;
                width: 0;
                height: 0;
                bottom: -15px;
                left: 50%;
                transform: translate(-50%, 0);
                border-right: 7px solid transparent;
                border-left: 7px solid transparent;
                border-bottom: 9px solid #f7f8fc;
              }
              .hasChildren{
                position: relative;
              }
              .hasChildren:hover:after{
                transform: rotate(180deg)
              }
              .hasChildren:after{
                content: '';
                position: absolute;
                width: 0;
                height: 0;
                top: 13px;
                right: 3px;
                border-right: 4px solid transparent;
                border-left: 4px solid transparent;
                border-top: 5px solid #1f2129;
                transition: all 0.1s ease-in-out;
              }
              .other-children{
                position: absolute;
                background: #f7f8fc;
                left: 0;
                top: 28px;
                display:none;
                z-index: 99;
              }
              .other-children:hover{
                display:block;
              }
              .other-child{
                padding: 4px 17px 4px 8px !important;
              }
              .other-child:hover{
                background: rgba(255, 225, 0, 0.2);
              }
              .hasChildren:hover .other-children{
                display: block;
              }
            `}
        </style>
      </div>
    )
  }

  return (
    <div className="item-wrap">
      <p className="name">其他</p>
      <div className="item-list">
        {renderList()}
      </div>
    </div>
  )
}
